import { Injectable } from '@angular/core'
import { Response } from '@angular/http'
import { CookieService } from 'ngx-cookie'
import 'rxjs/add/operator/map'
import { Globals } from '../helpers'
import { User } from './../models'
import { HttpInterceptor } from './http-error.interceptor'

@Injectable()
export class AuthenticationService {
  private userKey = 'current_user'
  private accessTokenKey = 'access_token'
  private refreshTokenKey = 'refresh_token'
  private accountServiceUrl: string

  constructor(
    private http: HttpInterceptor,
    private globals: Globals,
    private _cookieService: CookieService
  ) {
    this.accountServiceUrl = globals.url + 'auth'
  }

  public login(username: string, password: string, remember: boolean) {
    const body = {
      username,
      password,
      remember
    }
    return this.http
      .post(this.accountServiceUrl, body)
      .map((response: Response) => response.json())
  }

  public logout() {
    return this.http.delete(this.accountServiceUrl).map((response: Response) => (response ? response.json() : null))
  }

  public getCurrentUser() {
    return this.http
      .get(this.accountServiceUrl)
      .map((response: Response) => (response ? response.json() : null))
  }

  public changePassword(user: User) {
    return this.http
      .put(this.accountServiceUrl + '/password', user)
      .map((response: Response) => response.json())
  }

  public clearCookies() {
    localStorage.removeItem(this.accessTokenKey)
    localStorage.removeItem(this.userKey)
  }

  public getStorageValue(key: string) {
    let value = localStorage.getItem(key)
    try {
      return JSON.parse(value);
    } catch (error) {
      return value || null;
    }
  }

  public getCurrentUserCookie(): User {
    // accessToken present?
    if (this.getStorageValue(this.accessTokenKey)) {
      return this.getStorageValue(this.userKey) as User
    }
    return null
  }
  public getCurrentUserToken(): string {
    // accessToken present?
    return this.getStorageValue(this.accessTokenKey)
  }
  public saveUser(data) {
    localStorage.setItem(this.userKey, JSON.stringify(data.user))
    localStorage.setItem(this.accessTokenKey, data.access_token)
    localStorage.setItem(this.refreshTokenKey, data.refresh_token)
  }
}
